import Icon from '../components/Icon.vue'

Icon.register({
  recycle: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M184.6 261.9C187.8 275.9 172.4 286.5 160.5 279.1L119.8 253.6 68.9 335C55.6 356.3 71 384 96 384H148C154.6 384 160 389.4 160 396V436C160 442.6 154.6 448 148 448H96.1C20.8 448-25.2 365 14.7 301.1L65.5 219.7 24.8 194.3C12.7 186.7 15.8 168.3 29.7 165.1L139.9 139.7C148.5 137.7 157.1 143.1 159.1 151.7L184.6 261.9zM283.1 79L324.4 145.1 283.7 170.5C271.6 178 274.7 196.5 288.6 199.7L398.8 225.1C407.5 227.1 416 221.7 418 213.1L443.4 102.9C446.6 89.1 431.4 78.2 419.4 85.7L378.7 111.2 337.4 45.1C299.9-15 212.2-15.1 174.6 45.1L156.6 73.8C153.1 79.5 154.8 86.9 160.4 90.4L194.4 111.6C200 115.1 207.4 113.4 210.9 107.8L228.9 79C241.6 58.7 270.8 59.3 283.1 79zM497.3 301.1L469.8 257.1C466.3 251.4 458.9 249.7 453.2 253.2L419.4 274.4C413.8 277.9 412 285.3 415.6 290.9L443.1 335C456.4 356.3 441.1 384 416 384H320V336C320 321.8 302.8 314.6 292.7 324.7L212.7 404.7C206.4 410.9 206.4 421.1 212.7 427.3L292.7 507.3C302.7 517.3 320 510.3 320 496V448H415.9C491.2 448 537.2 365 497.3 301.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/recycle.js
// module id = IvfL
// module chunks = 144